module.exports = __webpack_public_path__ + "static/media/roti-menu-small.326d0c04.png";